import { Component, EventEmitter, OnInit, ViewChild } from "@angular/core";
import { NgxSpinnerService } from "ngx-spinner";
import { SelectItem } from "primeng/api";
import { NotificationTypes } from "src/app/app.enums";
import { ArtFlowSelectItem } from "src/app/models/artflow.selectitem";
import { EmailEventTypeService } from "src/app/Services/email-event-type.service";
import { EmailEventsService, EmailParameterResponse, SendEmailEventData } from "src/app/Services/email-events.service";
import { NotificationsService } from "src/app/Services/shared/notifications.service";
import { copyToClipboard } from 'src/app/app.functions';
import { AngularEditorComponent, AngularEditorConfig } from '@kolkov/angular-editor';
import { EmailEventsFilters } from "src/app/Services/auth.service";
import { Events, Parameters, SaveTemplates } from "src/app/models/emailevents.model";
import { TranslocoService } from "@jsverse/transloco";

@Component({
    selector: 'email-setting-template-dailog',
    templateUrl: './email-setting-template-dailog.component.html',
    inputs: ['displayDialog', 'isEditMode', 'emailEvents', 'selectedEmailTemplate', 'selectedEmailParameter', 'emailParameters'],
    outputs: ['onCloseEmailTemplateDailog', 'fetchEmailTemplate'],
    standalone: false
})

export class EmailSettingTemplateDailogComponent implements OnInit {
  @ViewChild('emailEditor') emailEditor!: AngularEditorComponent;
  public isEditMode: boolean = false;
  public displayDialog: boolean = false;
  public emailPreviewVisible: boolean = false;
  public loadedEmailTemplateParameters: boolean = false;
  public isAddEmailEventDailogVisible: boolean = false;
  public isEditorInVisualMode: boolean = true;
  public editorConfig: AngularEditorConfig = {
    outline: true,
    rawPaste: true,
    editable: true,
    spellcheck: true,
    height: 'auto',
    minHeight: '250px',
    translate: 'yes',
    enableToolbar: true,
    showToolbar: true,
    defaultParagraphSeparator: '',
    defaultFontName: '',
    defaultFontSize: '',
    sanitize: false,
    toolbarPosition: 'top',
  };
  public selectedEmailTemplate: SaveTemplates = {
    Guid: '',
    HtmlText: '',
    EmailEventId: '',
    Subject: ''
  };
  public EmailParameterData: EmailParameterResponse = {} as EmailParameterResponse;
  public emailEventsFormData!: Events;
  public selectedEmailEvent?: ArtFlowSelectItem;
  public emailEvents: Events[] = [];
  public emailParametersForAddEvents: SelectItem[] = [];
  public emailParameters: Parameters[] = [];
  public selectedEmailParameterId!: string;
  public selectedEmailParameter: string | null = null;
  public testEmailAddress: string = '';
  public onCloseEmailTemplateDailog = new EventEmitter<boolean>();
  public fetchEmailTemplate = new EventEmitter<void>();

  constructor(
    private ngxSpinnerService: NgxSpinnerService,
    private notificationsService: NotificationsService,
    private emailEventsService: EmailEventsService,
    private emailEventTypeService: EmailEventTypeService,
    private transloco: TranslocoService) {
    this.emailEventsFormData = new Events();
  }

  ngOnInit(): void {
    if (this.isEditMode == true) {
      console.log(this.emailParameters)
    }
  }

  public onCloseDialog() {
    this.displayDialog = false
    this.isEditMode = false;
    this.selectedEmailTemplate = new SaveTemplates();
    this.onCloseEmailTemplateDailog.emit(this.displayDialog)
  }

  public onAddEmailEvents() {
    this.isAddEmailEventDailogVisible = true
    this.getEmailParameters();
  }

  public onCloseEmailEventsDialog($event: boolean) {
    this.emailEventsFormData = new Events();
    // this.selectedEmailParameters = []
    this.isAddEmailEventDailogVisible = $event
  }

  public showEmailLogDailog() {
    this.emailPreviewVisible = true
  }

  public fetchEmailEvents(): void {
    this.ngxSpinnerService.show();

    // Here 0 = All, 1 = SystemDefined, 2 = UserDefined
    this.emailEventTypeService.fetchEmailevents(EmailEventsFilters.All).subscribe({
      next: (emailEvents: Events[]) => {
        this.emailEvents = emailEvents.map(evt => ({
          Id: evt.Id,
          Name: evt.Name,
          Description: evt.Description,
          IsPredefined: evt.IsPredefined,
          CreatedDate: evt.CreatedDate,
          EmailParameterIds: evt.EmailParameterIds,
          label: evt.Name,
          value: evt.Id
        }));

        console.log(this.emailEvents, 'emailEvents');
        this.ngxSpinnerService.hide();
      },
      error: (error) => {
        console.error('Error fetching email events:', error);
        this.notificationsService.showNotification(this.transloco.translate('emailSettingTemplateDailog.error'), this.transloco.translate('emailSettingTemplateDailog.failedToFetchEmailEvents'), NotificationTypes.Error);
        this.ngxSpinnerService.hide();
      }
    });
  }


  public getEmailParameters() {
    this.emailEventTypeService.fetchEmailParameters().subscribe((emailParameters) => {
      this.emailParametersForAddEvents = emailParameters.map((item) => {
        return { label: item.ParameterName, value: item.Guid };
      });
      console.log('emailParameters: ', this.emailParameters);
    }, (error) => { console.error(error); });
  }

  public onEmailEventChanged($event: any) {
    console.log($event);
    var eventId = $event.value;
    // this.getEmailTemplate(eventId);
    this.getEmailTemplateParameters(eventId);
  }

  private getEmailTemplateParameters(eventId: string) {
    this.loadedEmailTemplateParameters = false;
    this.emailEventTypeService.fetchEmailParameters(eventId).subscribe((emailEvents: Parameters[]) => {
      this.emailParameters = emailEvents;
      console.log(this.emailParameters)
      this.loadedEmailTemplateParameters = true;
    }, (error) => { console.error(error); });
  }

  public onEmailParameterChanged($event: any) {
    this.selectedEmailParameterId = $event.value;
    console.log("selectedEmailParameterId", this.selectedEmailParameterId)
    const emailparameter = this.emailParameters.find((p) => p.Guid === $event.value);
    this.EmailParameterData.ParameterUsage = emailparameter?.ParameterUsage || ''
    this.EmailParameterData.ParameterDescription = emailparameter?.ParameterDescription || ''
    console.log(this.EmailParameterData)
  }

  public insertEmailParameter($event: any) {
    const editorElement = this.emailEditor.textArea.nativeElement;
    const cursorPosition = this.getCursorPosition(editorElement);
    if (cursorPosition > -1) {
      const selectedParameter = this.emailParameters.find(param => param.Guid === this.selectedEmailParameter);
      this.insertTextAtCursorPosition(cursorPosition, selectedParameter?.ParameterName);
    }
  }

  private getCursorPosition(editorElement: HTMLTextAreaElement): number {
    const selection = window.getSelection();
    if (selection && selection.rangeCount > 0) {
      const range = selection.getRangeAt(0);
      const preSelectionRange = range.cloneRange();
      preSelectionRange.selectNodeContents(editorElement);
      preSelectionRange.setEnd(range.startContainer, range.startOffset);
      const start = preSelectionRange.toString().length;
      return start + range.toString().length;
    }
    return -1;
  }

  private insertTextAtCursorPosition(cursorPosition: number, parameterText: string | undefined): void {
    var currentValue = this.selectedEmailTemplate.HtmlText?.replace(/&nbsp;/g, ' ');
    const newValue = (currentValue ? currentValue.substring(0, cursorPosition) : '') + '{{' + parameterText + '}}' + (currentValue ? currentValue.substring(cursorPosition) : '');
    this.selectedEmailTemplate.HtmlText = newValue.replace(/&nbsp;/g, ' ');
    this.selectedEmailParameter = null;
  }

  public onViewModeChanged($event: boolean) {
    this.isEditorInVisualMode = $event;
  }

  public copySelectedEmailParameter($event: any) {
    const selectedParameter = this.emailParameters.find(param => param.Guid === this.selectedEmailParameter);
    if (selectedParameter && selectedParameter.ParameterName) {
      var appendCurlyBrackets = `{{${selectedParameter.ParameterName}}}`;
      copyToClipboard(appendCurlyBrackets);
      this.notificationsService.showNotification(this.transloco.translate('emailSettingTemplateDailog.success'), this.transloco.translate('emailSettingTemplateDailog.parameterCopiedToClipboard'), NotificationTypes.Success);
    }
  }

  public copySelectedEmailParameters($event: Parameters) {
    // const selectedParameter = this.emailParameters.find(param => param.Guid === this.selectedEmailParameter);
    if ($event.ParameterName) {
      var appendCurlyBrackets = `{{${$event.ParameterName}}}`;
      copyToClipboard(appendCurlyBrackets);
      this.notificationsService.showNotification(this.transloco.translate('emailSettingTemplateDailog.success'), this.transloco.translate('emailSettingTemplateDailog.parameterCopiedToClipboard'), NotificationTypes.Success);
    }
  }

  public saveEmailParameterField($event: any) {
    this.EmailParameterData.Guid = this.selectedEmailParameterId;
    this.ngxSpinnerService.show();
    this.emailEventTypeService.saveEmailParameterData(this.EmailParameterData).subscribe(
      (response) => {
        this.ngxSpinnerService.hide();
        if (response.Success) {
          this.notificationsService.showNotification('Success', response.ResponseMessage, NotificationTypes.Success);
        } else {
          console.error(response);
          this.notificationsService.showNotification('Error', response.ResponseMessage, NotificationTypes.Error);
        }
      }, (error) => { console.error(error); this.ngxSpinnerService.hide(); });
    console.log(this.EmailParameterData);
  }

  public saveEmailTemplate($event: any) {
    if (this.selectedEmailTemplate.HtmlText) {
      this.selectedEmailTemplate.HtmlText = this.selectedEmailTemplate.HtmlText?.replace(/&nbsp;/g, ' ');
    }
    this.selectedEmailTemplate.Guid = this.selectedEmailParameterId;
    // Ensure isSendToBccEmail is included in the payload (defaults to false if not set)
    this.selectedEmailTemplate.IsSendToBccEmail = this.selectedEmailTemplate.IsSendToBccEmail ?? false;
    console.log(this.selectedEmailTemplate);
    this.ngxSpinnerService.show();
    this.emailEventsService.saveEmailEvents(this.selectedEmailTemplate).subscribe((response) => {
      this.ngxSpinnerService.hide();
      if (response.Success) {
        this.notificationsService.showNotification('Success', response.ResponseMessage, NotificationTypes.Success);
        this.onCloseDialog();
        this.fetchEmailTemplate.emit();
      } else {
        console.error(response);
        this.notificationsService.showNotification('Error', response.ResponseMessage, NotificationTypes.Error);
      }
    }, (error) => {
      console.error(error);
      this.ngxSpinnerService.hide();
    });
  }

  public sendTestEmail($event: any) {
    const testData: SendEmailEventData = {
      SendTo: this.testEmailAddress,
      Subject: this.selectedEmailTemplate.Subject,
      HtmlContent: this.selectedEmailTemplate.HtmlText
    };

    this.emailEventsService.sendTestEmail(testData).subscribe((response) => {
      this.ngxSpinnerService.hide();
      if (response.Success) {
        this.testEmailAddress = '';
        this.notificationsService.showNotification('Success', response.ResponseMessage, NotificationTypes.Success);
      } else {
        this.notificationsService.showNotification('Error', response.ResponseMessage, NotificationTypes.Error);
      }
    }, (error) => { console.error(error); this.ngxSpinnerService.hide(); });
  }
}